import { useAuth } from "@/context/AuthContext";
import { ClientRow } from "@/components/ClientRow";
import { Users } from "lucide-react";

const HEADERS = ["Client ID", "Client", "Company", "Contact", "Status", "Assigned", "Tags", "actions"];

export function ClientTable({ clients, loading, onEdit, onDelete, onAddNew, onAssign }) {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";

  return (
    <div className="bg-white border border-gray-200 rounded-sm overflow-hidden shadow-sm">
      <table className="w-full text-left">
        <thead>
          <tr className="bg-gray-50 border-b border-gray-200">
            {HEADERS.map((h) => (
              <th key={h} className="text-xs font-bold uppercase tracking-wider text-gray-500 py-3 px-4">
                {h === "actions" ? "" : h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody data-testid="clients-table-body">
          {loading ? (
            <tr><td colSpan={8} className="py-12 text-center text-sm text-gray-400">Loading…</td></tr>
          ) : clients.length === 0 ? (
            <tr><td colSpan={8} className="py-16 text-center">
              <Users className="w-10 h-10 text-gray-300 mx-auto mb-3" strokeWidth={1.5} />
              <p className="text-sm text-gray-500 font-medium">No clients found</p>
              <button onClick={onAddNew} className="text-[#002FA7] text-sm font-semibold mt-2 hover:underline">Add your first client</button>
            </td></tr>
          ) : clients.map((c) => (
            <ClientRow key={c.id} client={c} isAdmin={isAdmin} onEdit={onEdit} onDelete={onDelete} onAssign={onAssign} />
          ))}
        </tbody>
      </table>
    </div>
  );
}
